
/*
 * renders href attrribute
 * @param true or false to add the indeterminate property
 * @example <input type='checkbox' data-binding='indeterminate: model.indeterminate'></a>
 */
ko.bindingHandlers.indeterminate = {
  update: function(element, valueAccessor) {
    var value;
    value = ko.unwrap(valueAccessor());
    return $(element).prop("indeterminate", value);
  }
};
